import script from "./BaseCaption.vue?vue&type=script&lang=ts"
export * from "./BaseCaption.vue?vue&type=script&lang=ts"

const __exports__ = script;

export default __exports__